module.exports = __webpack_public_path__ + "files/551c80eb8f42bb044aca196db87b8ae5.png";